'use client'
import { FormattedMessage } from "react-intl";
import styles from "@/app/styles/page/forgot-password/forgot-password-page.module.scss";

const ForgotPasswordInfo = ({ data }) => {
    return (
        <div className={styles.forgotPasswordInfo}>
            <h1 className={styles.title}>
                {data.forgotPasswordPage.forgot_password_title}
            </h1>
            <p className={styles.text}>
                {data.forgotPasswordPage.forgot_password_text}
            </p>
        </div>
    )
}
export default ForgotPasswordInfo;